import { render } from "./ChangesConfirmationModal.vue?vue&type=template&id=77e8540a"
import script from "./ChangesConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ChangesConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__